import { cn } from '@/lib/utils';
import type { CSSProperties } from 'react';

interface SkeletonProps {
  className?: string;
  style?: CSSProperties;
}

/**
 * Base skeleton block with shimmer animation.
 * Uses CSS variable-aware colors for dark/light mode compatibility.
 */
export function Skeleton({ className, style }: SkeletonProps) {
  return (
    <div
      className={cn('skeleton-shimmer rounded-md', className)}
      style={style}
      aria-hidden="true"
    />
  );
}
